import apiService from '../http.service';
import { appConfig } from '../../app.config';
import { APP_TYPES } from '@config';
import Scene from '@scene';
import { EventManager, EVENTS } from '@components/Events/events';

class CalculateTabService {

  constructor() {
    this.config = null;
  }

  getSteelTypes() {
    return apiService.get({ query: appConfig.path.STEEL_TYPES });
  }

  initCalculateTab (config, appType) {
    // const types = {
    //   [APP_TYPES.GENERAL_CALCULATION]: 'GeneralCalculation',
    //   [APP_TYPES.BRACKET_ATTACHMENT]: 'BracketAttachment',
    //   [APP_TYPES.SAFETY_BARRIER]: 'SafetyBarrier',
    //   [APP_TYPES.REBAR_REINFORCEMENT]: 'RebarReinforcement',
    // };

    // old request to GetAnchorResultsInternal
    // return Promise.all([
    //   apiService.get({ query: `${appConfig.path.ANCHOR_RESULTS_INTERNAL}?appType=${types[appType]}` })
    // ]);

    // new request to GetAnchorResultsWeb

    // this.config = config;

    return Promise.all([
      apiService.post({
        query: appConfig.path.ANCHOR_RESULTS,
        data:{"wto": config}
      }),
      // this.prepareReportImage(),
      this.calculateProfileResistance(config, appType)
    ]);
  }

  getAnchorImageSrc (anchorName, appType) {
    const type = appType === APP_TYPES.REBAR_REINFORCEMENT ? 1 : 0;

    return apiService.get({ query: `${appConfig.path.GET_PHOTO}?internalName=${encodeURIComponent(anchorName)}&type=${type}` })
      .then(res => {
        if (res) {
          const b64encoded = btoa(new Uint8Array(res._buffer).reduce((data, byte) => data + String.fromCharCode(byte), ''));

          return 'data:image/jpeg;base64,' + b64encoded;
        }
    });
  }

  getNailImageSrc(nailName) {
    return apiService.get({ query: `${appConfig.path.GET_PHOTO}?internalName=${encodeURIComponent(nailName)}&type=2` })
      .then(res => {
        if (res) {
          const b64encoded = btoa(new Uint8Array(res._buffer).reduce((data, byte) => data + String.fromCharCode(byte), ''));
          return 'data:image/jpeg;base64,' + b64encoded;
        }
    });
  }

  getInstallationMethod (anchorName) {
    return apiService.get({ query: `${appConfig.path.INSTALLATION_METHOD}?anchorInternalName=${encodeURIComponent(anchorName)}` })
      .then(res => {
      return appConfig.BASE_URL + res;
    });
  }

  getInstallationData (anchorName, diameter, type) {
    return apiService.get({
      query: `${appConfig.path.INSTALLATION_DATA}?anchorInternalName=${encodeURIComponent(anchorName)}`+
        `&diameterIdx=${diameter}&typeIdx=${type}`
    });
  }

  getFile (anchorName, doc) {
    return apiService.get({
      query: `${appConfig.path.GET_DOCUMENT}?anchorInternalName=${encodeURIComponent(anchorName)}&requestedDocument=${doc}`
    });
  }

  openFile (link) {
    if (typeof(link) === 'string')
      window.open(`${appConfig.BASE_URL}${link}`);
  }

  getResultErrorMessages (anchorName, diameter, type) {
    return apiService.get({
      query: `${appConfig.path.ERROR_MESSAGES}?anchorInternalName=${encodeURIComponent(anchorName)}&diameterIdx=${diameter}&typeIdx=${type}`
    });
  }

  generateReportGr (
    config, format, anchorIdx, diameterIdx, typeIdx, nailAnchorIdx, nailDiameterIdx, nailTypeIdx, rebarName, isDefault, reportOptions
  ) {
    let method = 'POST';
    let data = {"rwd": {
          "wto": config,
          "format": format,
          "anchorIdx": anchorIdx,
          "diameterIdx": diameterIdx,
          "typeIdx": typeIdx,
          "nailIdx": nailAnchorIdx,
          "nailDiameterIdx": nailDiameterIdx,
          "nailTypeIdx": nailTypeIdx,
          "rebarName": rebarName,
          "isDefault": isDefault,
          "crtDate": new Date().toLocaleDateString() + ';' + new Date().toLocaleTimeString(),
          "reportOptions": reportOptions 
          }};
    const body = data ? JSON.stringify(data) : null;
    const headers = apiService.getHeaders(body);

    return Promise.resolve(
      fetch(appConfig.BASE_URL + appConfig.API_PATH + appConfig.path.GENERATE_REPORT_WEB, {
        method,
        body,
        headers
      })
      .then(res => {
        if (res.status !== 200)
          return res.json(); // return exception
        else 
          return res.blob(); // return pdf file as a blob
      })
      .catch(apiService.handleError)
    );
  }

  generateReport({ rebarName, anchorId, diameter, type }) {
    if (!this.config) return;

    const data = {
      'rwd': { 'wto': this.config },
      'format': 'PDF',
    };

    if (rebarName) {
      data.rebarName = rebarName;
    } else {
      data.anchorIdx = anchorId;
      data.diameterIdx = diameter;
      data.typeIdx = type;
    }

    return apiService.post({
      query: appConfig.path.GENERATE_REPORT_WEB,
      data
    });
  }

  prepareReportImage() {
    Scene.getSnapshots(this.prepareReportImageRequest);
  }

  prepareReportImageRequest(id, content) {
    return apiService.post({
      query: `${appConfig.path.PREPARE_REPORT_IMAGE}`,
      data: {
        image: {
          id: id,
          content: content
        }
      }
    }).then((res) => {
      if (id === "GEOMETRY2D") { // 2nd Image 
        if (res === true) 
          EventManager.emit(EVENTS.REPORT_IMAGES_SENT, true);
        else 
          EventManager.emit(EVENTS.REPORT_IMAGES_SENT, false);
      }
    });
  }

  updateClientUnits(units) {
    return apiService.post({
      query: appConfig.path.UPDATE_UNITS,
      data: {
        "units": units
      }
    });
  }
  
  runFEMCalculation(config, appType) {
    return apiService.post({
      query: appConfig.path.RUN_FEM_CALCULATION,
      data:{"wto": config}
    });
  }

  cancelFEMCalculation() {
    return apiService.get({
      query: appConfig.path.CANCEL_FEM_CALCULATION
    });
  }

  calculateProfileResistance(config, appType) {
    if (appType === APP_TYPES.SAFETY_BARRIER) {
      return apiService.post({
        query: appConfig.path.CALCULATE_PROFILE_RESISTANCE,
        data: {"wto": config}
      });
    } else {
      return undefined;
    }
  }
  
  keepCalculationRunning() {
    return apiService.get({
      query: appConfig.path.KEEP_CALCULATION_RUNNING
    });
  }

  cancelCalculation() {
    return apiService.get({
      query: appConfig.path.CANCEL_CALCULATION
    });
  }
  
}

export default new CalculateTabService();



// WEBPACK FOOTER //
// ./src/services/requests/calculate-tab.service.js